import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitInstructions = async ({
  visitId,
  patientId,
  sessionId,
  stepId,
  contnt,
  contntDe,
  contntEs,
  isAllInstruction,
  disallowInvInstructionsSelection,
}) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (patientId) params.append("patient_id", patientId);
  if (sessionId) params.append("session_id", sessionId);
  if (stepId) params.append("step_id", stepId);

  const payload = { contnt: contnt ?? "" };
  if (contntDe !== undefined) payload.contnt_de = contntDe;
  if (contntEs !== undefined) payload.contnt_es = contntEs;
  if (isAllInstruction !== undefined) payload.is_all_instruction = isAllInstruction;
  if (disallowInvInstructionsSelection !== undefined) {
    payload.disallow_inv_instructions_selection = disallowInvInstructionsSelection;
  }

  const res = await axios.put(
    `${__API_URL__}/api/photos/visits/${visitId}/instructions/?${params.toString()}`,
    payload,
    { headers: { Authorization: `Token ${token}` } }
  );

  return res.data;
};

const useUpdateVisitInstructionsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitInstructions,
    onSuccess: () => {
      toast.success("Instructions updated");
      queryClient.invalidateQueries({ queryKey: ["visits"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update instructions");
    },
  });
};

export default useUpdateVisitInstructionsMutation;
